import { Box, styled } from "@mui/material";


export const FlexBoxSpaceBetween = styled(Box)(()=>({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'wrap'
}))